"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FocoNaCarreira = function FocoNaCarreira() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 876 876"
  }, _react.default.createElement("path", {
    fill: "#fff",
    d: "M0 0h876v876H0z"
  }), _react.default.createElement("circle", {
    cx: "437",
    cy: "1070",
    r: "316",
    fill: "url(#paint0_linear)"
  }), _react.default.createElement("circle", {
    cx: "411.51",
    cy: "464.48",
    r: "230.57",
    fill: "#63DC3E"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M865.3 424.63h-.06l-111.65.7c-6.5-164.11-138.82-296.42-302.93-302.93l.7-111.65a10.68 10.68 0 10-21.37-.13l-.7 111.63C262.01 126.8 126.8 262.02 122.24 429.3L10.6 430a10.68 10.68 0 10.07 21.37h.07l111.65-.7c6.5 164.11 138.81 296.42 302.93 302.93l-.7 111.65A10.69 10.69 0 00435.23 876h.07a10.68 10.68 0 0010.7-10.62l.7-111.63c167.28-4.55 302.5-139.77 307.05-307.05l111.64-.7a10.68 10.68 0 00-.07-21.37zm-133.09.84l-56.68.35a238.19 238.19 0 00-225.36-225.36l.35-56.68c152.44 6.41 275.28 129.25 281.7 281.69zM563.64 447.9h.07l90.55-.57A216.75 216.75 0 01447.3 654.27l.55-86.8a10.69 10.69 0 00-10.62-10.76h-.07a10.69 10.69 0 00-10.68 10.62l-.55 86.81a216.78 216.78 0 01-204.1-204.1l75.33-.47a10.68 10.68 0 00-.14-21.37l-75.31.48a216.76 216.76 0 01206.95-206.95l-.53 83.17a10.67 10.67 0 0010.62 10.76h.07a10.68 10.68 0 0010.68-10.62l.52-83.18a216.79 216.79 0 01204.11 204.1l-90.56.57a10.68 10.68 0 10.07 21.36v.01zM429.16 143.64l-.36 56.7a238.14 238.14 0 00-228.47 228.47l-56.7.36c4.6-155.39 130.14-280.93 285.53-285.53zm-285.4 306.9l56.69-.36A238.2 238.2 0 00425.8 675.54l-.35 56.68C273 725.81 150.18 602.97 143.76 450.53zm303.06 281.82l.36-56.7a238.14 238.14 0 00228.47-228.47l56.7-.36c-4.6 155.39-130.14 280.93-285.53 285.54z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M437.17 435.55c24.94 0 45.16-24.56 45.16-54.86s-6.64-54.86-45.16-54.86c-38.53 0-45.17 24.56-45.17 54.86s20.22 54.86 45.17 54.86zm-85.31 83.76c0-1.85-.01-.52 0 0zm170.61 1.44c.03-.5.01-3.5 0 0z"
  }), _react.default.createElement("path", {
    fill: "#242523",
    d: "M522.38 517.1c-.84-52.78-7.73-67.82-60.48-77.34 0 0-7.43 9.47-24.73 9.47s-24.74-9.47-24.74-9.47C360.26 449.18 352.95 464 352 515.4c-.08 4.2-.12 4.41-.13 3.93v5.54s12.56 25.32 85.3 25.32c72.75 0 85.3-25.32 85.3-25.32l.01-4.1c-.01.3-.04-.28-.1-3.66z"
  }), _react.default.createElement("defs", null, _react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "437",
    x2: "437",
    y1: "627.5",
    y2: "1386",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#F2F2F2"
  }), _react.default.createElement("stop", {
    offset: "0.31",
    stopColor: "#fff",
    stopOpacity: "0"
  }))));
};

var _default = FocoNaCarreira;
exports.default = _default;